import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=4caf8b74&scoped=true&"
import script from "./noticeList.vue?vue&type=script&lang=js&"
export * from "./noticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caf8b74",
  null
  
)

export default component.exports